<div mat-dialog-content>
  <app-addedit-site
    [siteData]="data"
    (onFormSubmit)="onFormSubmit($event)"
  ></app-addedit-site>
</div>
<div mat-dialog-actions align="end"></div>
